import { Label, Popup } from './';
import React from 'react';

const TeamLabel = ({ team }) => (
  <Popup trigger={<Label>{team.abbreviation}</Label>}>{team.name}</Popup>
);

export default TeamLabel;



// WEBPACK FOOTER //
// ./src/components/TeamLabel.js